<div class="container-fluid">
	<div class="row my-3 align-items-center">
		<div class="col-8 col-md-10">
			<h1 class="text-capitalize" *ngIf="bank_account">
				Movimientos Bancarios - {{bank_account.alias || bank_account.name}}
			</h1>
			<h1 class="text-capitalize" *ngIf="!bank_account">
				Movimientos Bancarios
			</h1>
		</div>
		<div class="col-4 col-md-2 text-end">
			<button type="button" (click)="exportExcel()" class="btn btn-secondary" *ngIf="movement_list.length">
				Exportar
			</button>
		</div>
	</div>

	<div class="row mb-3" *ngIf="bank_account">
		<div class="col-12">
			<div class="alert alert-info mb-0">
				<strong>{{bank_account.bank}}</strong> - {{bank_account.account}}
				<span *ngIf="bank_account.currency"> - {{bank_account.currency | uppercase}}</span>
				<span *ngIf="bank_account.email"> - {{bank_account.email}}</span>
			</div>
		</div>
	</div>

	<div class="card p-3 mt-3">
		<app-loading [is_loading]="is_loading"></app-loading>
		<div *ngIf="!is_loading && movement_list.length == 0" class="text-center p-3">
			<h4>No hay movimientos registrados</h4>
		</div>
		<div class="table-responsive" *ngIf="movement_list.length > 0">
			<table class="table table-sm table-nowrap mb-0">
				<thead class="thead-light">
					<tr>
						<th>ID</th>
						<th>Tipo</th>
						<th>Monto</th>
						<th>Fecha</th>
						<th>Referencia</th>
						<th>Origen</th>
						<th class="text-end">Acciones</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let m of movement_list">
						<td>{{m.id}}</td>
						<td>
							<span class="badge bg-secondary">{{getTransactionTypeLabel(m.transaction_type)}}</span>
							<span class="badge bg-info ms-1" *ngIf="m.type">{{m.type == 'expense' ? 'Egreso' : 'Ingreso'}}</span>
						</td>
						<td>{{m.total | currency:'$'}} {{m.currency_id}}</td>
						<td>{{m.paid_date | date:'dd/MM/yyyy'}}</td>
						<td>{{m.reference || '---'}}</td>
						<td>
							<ng-container *ngFor="let o of getOrigins(m); let last = last">
								<a *ngIf="o.purchase_id" [routerLink]="['/purchase/edit', o.purchase_id]">
									OC #{{o.purchase_id}}
								</a>
								<a *ngIf="o.order_id && !o.purchase_id" [routerLink]="['/view-order', o.order_id]">
									Orden #{{o.order_id}}
								</a>
								<a *ngIf="!o.purchase_id && !o.order_id && o.bill_id" [routerLink]="['/list-provider-bills', m.provider_user_id]">
									Recibo #{{o.bill_id}}
								</a>
								<span *ngIf="!last">, </span>
							</ng-container>
							<a *ngIf="getOrigins(m).length == 0 && m.payment_id" [routerLink]="['/view-payment', m.payment_id]">
								Pago #{{m.payment_id}}
							</a>
							<span *ngIf="getOrigins(m).length == 0 && !m.payment_id">---</span>
						</td>
						<td class="text-end">
							<button class="btn btn-sm btn-outline-primary mb-1" (click)="viewMovementDetail(m)">
								Detalle
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>

<app-modal [(show)]="show_detail_modal">
	<div class="card p-3" style="min-width:540px;" *ngIf="selected_movement">
		<h3>Movimiento #{{selected_movement.id}}</h3>

		<div *ngIf="loading_detail" class="text-center p-3">
			<app-loading [is_loading]="loading_detail"></app-loading>
		</div>

		<ng-container *ngIf="!loading_detail">

			<div class="row mb-3">
				<div class="col-6">
					<strong>Monto:</strong> {{selected_movement.total | currency:'$'}} {{selected_movement.currency_id}}
				</div>
				<div class="col-6">
					<strong>Recibido:</strong> {{selected_movement.amount_received | currency:'$'}} {{selected_movement.currency_id}}
				</div>
				<div class="col-6">
					<strong>Fecha:</strong> {{selected_movement.paid_date | date:'dd/MM/yyyy'}}
				</div>
				<div class="col-6">
					<strong>Tipo:</strong> {{getTransactionTypeLabel(selected_movement.transaction_type)}}
					({{selected_movement.type == 'expense' ? 'Egreso' : 'Ingreso'}})
				</div>
				<div class="col-6">
					<strong>Referencia:</strong> {{selected_movement.reference || '---'}}
				</div>
				<div class="col-6" *ngIf="selected_movement.card_ending">
					<strong>Terminación tarjeta:</strong> {{selected_movement.card_ending}}
				</div>
			</div>

			<div class="mb-3" *ngIf="selected_movement_info?.bank_account">
				<strong>Cuenta bancaria:</strong>
				{{selected_movement_info.bank_account.alias || selected_movement_info.bank_account.name}}
				- {{selected_movement_info.bank_account.bank}}
				- {{selected_movement_info.bank_account.account}}
			</div>

			<div class="mb-3" *ngIf="selected_movement_info?.provider">
				<strong>Proveedor:</strong>
				<a [routerLink]="['/list-provider-bills', selected_movement_info.provider.id]">
					{{selected_movement_info.provider.name | titlecase}}
				</a>
			</div>

			<div class="mb-3" *ngIf="selected_movement_info?.bank_movement_bills?.length">
				<h5>Recibos / Órdenes de compra vinculadas:</h5>
				<div class="table-responsive">
					<table class="table table-sm">
						<thead>
							<tr>
								<th>Recibo #</th>
								<th>Folio</th>
								<th>Orden Compra</th>
								<th class="text-end">Monto</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let bmb of selected_movement_info.bank_movement_bills">
								<td>{{bmb.bill?.id || '---'}}</td>
								<td>{{bmb.bill?.folio || '---'}}</td>
								<td>
									<a *ngIf="bmb.bill?.purchase_id" [routerLink]="['/purchase/edit', bmb.bill.purchase_id]">
										OC #{{bmb.bill.purchase_id}}
									</a>
									<span *ngIf="!bmb.bill?.purchase_id">---</span>
								</td>
								<td class="text-end">{{bmb.bank_movement_bill.amount | currency:'$'}} {{bmb.bank_movement_bill.currency_id}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<div class="mb-3" *ngIf="selected_movement_info?.bank_movement_orders?.length">
				<h5>Órdenes de venta vinculadas:</h5>
				<div class="table-responsive">
					<table class="table table-sm">
						<thead>
							<tr>
								<th>Orden #</th>
								<th class="text-end">Monto</th>
								<th>Moneda</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let bmo of selected_movement_info.bank_movement_orders">
								<td>
									<a *ngIf="bmo.order_id" [routerLink]="['/view-order', bmo.order_id]">
										Orden #{{bmo.order_id}}
									</a>
								</td>
								<td class="text-end">{{bmo.amount | currency:'$'}}</td>
								<td>{{bmo.currency_id}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<div *ngIf="!selected_movement_info?.bank_movement_bills?.length && !selected_movement_info?.bank_movement_orders?.length">
				<div class="alert alert-warning">
					No se encontraron recibos ni órdenes vinculadas a este movimiento.
				</div>
			</div>
		</ng-container>

		<div class="text-end mt-3">
			<button type="button" class="btn btn-secondary" (click)="show_detail_modal = false">Cerrar</button>
			<a *ngIf="selected_movement?.payment_id" class="btn btn-primary ms-2" [routerLink]="['/view-payment', selected_movement.payment_id]">
				Ir al Pago #{{selected_movement.payment_id}}
			</a>
		</div>
	</div>
</app-modal>
